module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai387-9f84e51ef7de5ac77c34145548dfae08.jpg";